'use client';

import { timezones } from '@wolfejs/core/utils/timezones';
import type { BuyerBusinessEntity } from '@wolfejs/ms-api-js/src/types/buyers';
import type { UserApiKeyEntity, UserEntity, UserProfileEntity } from '@wolfejs/ms-api-js/src/types/users';

import { AdminAccountForm } from '@wolfejs/ms-ui/AdminAccountForm';
import { AdminApiTokenForm } from '@wolfejs/ms-ui/AdminApiTokenForm';
import { AdminGeneralInfoForm } from '@wolfejs/ms-ui/AdminGeneralInfoForm';
import { AdminResetPasswordForm } from '@wolfejs/ms-ui/AdminResetPasswordForm';
import { DashboardPanel } from '@wolfejs/ms-ui/DashboardPanel';
import { Title } from '@wolfejs/ui/Title';
import { type UIComponentProps } from '@wolfejs/ui/types/UI';

type MyAccountProps = UIComponentProps & {
  buyerData?: BuyerBusinessEntity;
  profile?: Partial<UserProfileEntity> | undefined;
  userDetails: UserEntity;
  userApiKey?: Partial<UserApiKeyEntity> | undefined;
};

export const MyAccount = ({ buyerData, profile, userDetails, userApiKey }: MyAccountProps) => {
  if (!profile) return null;

  const { firstname, lastname, imageUrl } = profile;

  return (
    <div className="flex flex-col gap-4">
      <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
        <DashboardPanel>
          <div className="grid gap-6">
            <Title as="h3">Account</Title>
            <AdminAccountForm
              userId={userDetails?.id}
              defaultValues={{
                username: userDetails?.name,
                email: userDetails?.email,
                timezone: timezones.find(item => item.value === 'UTC' + profile.timezone?.toString()),
                phone: profile.phoneNumber,
                country: profile.address?.country,
                city: profile.address?.city,
                fullName: `${firstname} ${lastname}`,
              }}
            />
          </div>
        </DashboardPanel>
        <DashboardPanel>
          <div className="grid gap-6">
            <Title as="h3">Business Information</Title>
            <AdminGeneralInfoForm buyerData={buyerData} />
          </div>
        </DashboardPanel>
      </div>
      <div className="grid grid-cols-1">
        <DashboardPanel>
          <AdminResetPasswordForm />
        </DashboardPanel>
      </div>
      <div className="grid grid-cols-1">
        <DashboardPanel>
          <AdminApiTokenForm userApiKey={userApiKey} />
        </DashboardPanel>
      </div>
    </div>
  );
};
